import jssVariables from "../../jss_setup";

export const searchStripFlights = {
  searchStrip: {
    background: jssVariables.colors.base_color,
    smallscreen: {
      background: jssVariables.colors.base_color,
    },
  },
  loader: {
    color: jssVariables.colors.secondary_color,
  },
  icon: {
    color: jssVariables.colors.secondary_color,
  },
  loaderIcon: {
    color: jssVariables.colors.secondary_color,
  },
  loaderText: {
    color: jssVariables.colors.secondary_color,
  },
};

export const filtersBarFlights = {
  filtersBar: {
    background: "#8EA2B1",
    smallscreen: {
      color: "white",
    },
  },
};

export const flightStyles = {
  price: {
    color: jssVariables.colors.secondary_color,
  },
};
